import { defaultXAxisConfig } from '../constants.js';
import {
  SparklineXAxisInternalProps,
  SparklineXAxisProps,
} from '../types/sparkline-x-axis-props.js';

const getXAxisConfigDate = (value: number | Date) => {
  if (typeof value === 'number') {
    return new Date(value);
  }
  return value;
};

export const getXAxisConfig = (
  xAxis?: SparklineXAxisProps,
): SparklineXAxisInternalProps => {
  if (!xAxis) {
    return defaultXAxisConfig;
  }

  const defaultMin =
    xAxis.min === 'auto' || xAxis.min === 'data-min' || xAxis.min === undefined;
  const defaultMax =
    xAxis.max === 'auto' || xAxis.max === 'data-max' || xAxis.max === undefined;

  return {
    min: defaultMin
      ? 'data-min'
      : getXAxisConfigDate(xAxis.min as number | Date),
    max: defaultMax
      ? 'data-max'
      : getXAxisConfigDate(xAxis.max as number | Date),
  };
};
